export function enableScrolling() {
  document.getElementById('contract-details').style.zIndex = 0;
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}
